import React from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import '../assets/dashcss/core.css';
import '../assets/dashcss/demo.css';
import '../assets/dashcss/theme-default.css';

function Dashboard() {
  return (
    <>
    <div className="layout-wrapper layout-content-navbar">
      <div className="layout-container">
        <Sidebar />
        <Outlet />
      </div>
    </div>
    </>
  );
}

export default Dashboard;